module.exports = __webpack_public_path__ + "img/pro_five_5.7a6ceecb.jpg";